export function customScrollbar($rootScope) {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'AEC',
        scope: {
            onTotalScroll: '&onTotalScroll'
        }

    };
    return directive;

    function link(scope, element, attrs) {
       
        if (attrs.items) {

            var height = attrs.items * 33;
            if (height < attrs.maxHeight) {
                $(element).css('height', height)
            }
            else {
                $(element).css('height', attrs.maxHeight + 'px')
            }
        }

        $(element).ecbCustomScrollbar({
            theme: "dark",
            axis: "y",
            autoHideScrollbar: true,
            callbacks: {
                onTotalScroll: scope.onTotalScroll
            }
        });


    }
}




// WEBPACK FOOTER //
// ./src/directives/customScrollBar/customScrollBar.ts